import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../helpers/authContext";

import Alert, { ALERT_TYPE } from '../../../components/Alert/Alert';
import { general, Loading, Section, PaddedContent, List, ListItem, Button, Toolbar } from 'daymap-library';

const SIGN_OUT_STATE = {
    None: 1,
    SigningOut: 2,
    Complete: 3
}

const SignOut = () => {
    const navigate = useNavigate();
    const { lmsFetch } = useAuth();
    const [visitors, setVisitors] = useState(null);
    const [signingOut, setSigningOut] = useState(SIGN_OUT_STATE.None);
    const [selectedVisitorId, setSelectedVisitorId] = useState(null);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        const [getVisitors] = lmsFetch('/lms/api/checkin/visitors');
        const response = await getVisitors();

        console.log(response);
        setVisitors(response.data);
    }

    const visitorSelected = visitorId => {
        if (visitorId === selectedVisitorId)
            setSelectedVisitorId(null);
        else
            setSelectedVisitorId(visitorId);
    }

    const signOut = async () => {
        setSigningOut(SIGN_OUT_STATE.SigningOut);
        const [out] = lmsFetch(`/lms/api/checkin/visitors/out?visitorId=${selectedVisitorId}`, null, { method: 'PATCH' });
        const response = await out();

        if (response.ok)
            setSigningOut(SIGN_OUT_STATE.Complete);
    }

    if (!visitors)
        return <Loading message="Loading visitors"/>

    if (signingOut === SIGN_OUT_STATE.SigningOut)
        return <Loading message="Signing out" />

    if (signingOut === SIGN_OUT_STATE.Complete)
        return <SignOutComplete />

    return (
        <>
            <PaddedContent>
                Tap the your name in the list below, followed by the Sign Out button
            </PaddedContent>
            <Section>
                {visitors.length === 0 ? <PaddedContent>
                        <p>No visitors found for today</p>
                    </PaddedContent> :
                    <List>
                        {visitors.map(v => <ListItem 
                            title={v.FirstnameSurname}
                            onClick={() => visitorSelected(v.ID)}
                            selected={v.ID === selectedVisitorId}
                        />)}
                    </List>
                }
            </Section>
            <PaddedContent>
                <Toolbar>
                    <Button secondary text="Cancel" onClick={() => navigate('/visitors')}></Button>
                    <Button text="Sign Out" onClick={signOut} disabled={selectedVisitorId === null}></Button>
                </Toolbar>
            </PaddedContent>
        </>
    )
}

const SignOutComplete = () => {
    const { settings } = useAuth();
    const navigate = useNavigate();
    const [ secondsTilRedirect ] = general.useCountdown({ seconds: settings.KioskRedirectDelay, onZero: () => navigate('/visitors') });

    if(!(settings.KioskRedirectDelay > 0))
    {
        navigate('/visitors');
        return "";
    }
    

    return <Alert type={ALERT_TYPE.Success} heading="Sign Out Complete">
            Returning to Visitor home page in {secondsTilRedirect} seconds.
        </Alert>
}

export default SignOut;